import React from 'react'
import IndividData from "./IndividData"
import SchoolCommonData from "./SchoolCommonData"
import AllCommonData from "./AllCommonData"

import styled from "styled-components"
import media from "styled-media-query"

const Tables = ({ school, grade }) => {

   return (
      <TablesStyles school={school} grade={grade} >
         <IndividData school={school} grade={grade} />
         <SchoolCommonData school={school} grade={grade} />
         <AllCommonData school={school} grade={grade} />
      </TablesStyles>
   )
}

const TablesStyles = styled.section`
   width: 80%;
   margin: 120px auto;
   display: flex;
   flex-wrap: wrap;
   justify-content: space-between;
   ${media.lessThan("960px")`
      margin-top: 60px;
      width: 95%;
   `}

   .course-wrap {
      width: 48%;
      margin-top: 50px;
      ${media.lessThan("960px")`
         width: 100%;
      `}
   }

   
   table {
      width: 100%;
      thead {
         width: 100%;
         background-color: #FF3D01;
         tr {
            height: 40px;
            line-height: 40px;
            font-size: 2.5rem;
            color: #fff;
         ${media.lessThan("960px")`
            height: 35px;
            line-height: 35px;
            font-size: 2rem;
         `}
         }
      }
      tbody {
         tr {
            width: 100%;
            height: 40px;
            font-size: 2.5rem;
            line-height: 40px;
            text-align: center;
            border: 1px solid #D3D3D3;
            color: #6E6E6E;
         ${media.lessThan("960px")`
            height: 35px;
            line-height: 35px;
            font-size: 2rem;
         `}
            td {
               width: 50%;
               &:first-child {
                  border-right: 1px solid #D3D3D3;
               }
            }
         }
      }
   }

   .desc {
      padding: 20px 20px 0;
      font-size: 1.2rem;
      line-height: 2rem;
      color: #6E6E6E;
   }

   .course-a {
      display: ${({school, grade}) => {
         if (school === "jhs" && grade === 3) {
            return "block"
         } else {
            return "none"
         }
      }};
   }

   .course-b {
      display: ${({school, grade}) => {
         if (school === "hs" || school === "other") {
            return "none"
         } else if (school === "jhs" && grade === 3) {
            return "none"
         } else {
            return "block"
         }
      }};
   }

   .course-c, .course-d {
      display: ${({school}) => school === "other" ? "none" : "block"};
   }

   .course-e {
      display: ${({school}) => school === "es" ? "none" : "block"};
   } 

   .course-f {
      display: ${({school}) => school === "hs" ? "none" : "block" };
   }

   .course-g {
      display: ${({school}) => {
         if (school === "jhs") {
            return "block"
         }  else {
            return "none"
         }
      }};
   }

   .course-h {
      display: ${({school}) => {
         if (school === "hs") {
            return "none"
         } else if (school === "es") {
            return "none"
         } else {
            return "block"
         }
      }};
   }

   .course-i {
      display: ${({school}) => school === "es" ? "none" : "block" };
   }

   .course-j {
      display: ${({school}) => school === "es" ? "none" : "block"};
   }

`

export default Tables